import axios from 'axios';
import {
  AdType,
} from '../../types';
import { axiosConfig, serverUrl, streetsUrl } from '../../config';

export type MediaFile = {
  blobURL: string;
  _type: string;
};

export type IAdLoop = {
  mediaFile: MediaFile;
  duration: number;
  uniqueId: string;
  pop?: string;
};

type GetDeviceAdsProps = {
  partnerName?: string
};

export const getDeviceAds = async ({
  partnerName = '',
}: GetDeviceAdsProps): Promise<IAdLoop[]> => {
  // @ts-ignore
  const deviceId = window.DeviceApi.getDeviceId();

  // console.log(`[CLIENT] Requesting ads for device ${deviceId}, partner: ${partnerName}`);

  try {
    const response = await axios.get(
      `${serverUrl}/external/ads/${deviceId}`,
      {
        ...axiosConfig,
        params: {
          partnerName,
        },
      },
    );

    const ads = response?.data ? [response.data] : [];
    // console.log(`[CLIENT] Received ${ads.length} ads for device ${deviceId}`);

    return ads;
  } catch (error) {
    console.error(`[CLIENT] Error requesting ads for device ${deviceId}:`, error);
    return [];
  }
};

export const delay = (ms: number): Promise<void> => new Promise((resolve) => { setTimeout(resolve, ms); });

export type AdsQueue = {
  poppedAdsQueue: IAdLoop[];
  serverQueue: IAdLoop[];
  weatherQueue: any[];
  newsQueue: any[];
};

export type QueueWeights = {
  [AdType.Fallback]: number,
  [AdType.Component]: number,
  [AdType.Server]: number,
  [AdType.Weather]: number,
  [AdType.News]: number
};

export type QueueConfig = {
  weights: QueueWeights;
  queueCap: Record<string, number>;
  clientAdRequestIntervals: Record<string, number>;
};

export const getQueueConfig = async (): Promise<QueueConfig | { error: unknown }> => {
  try {
    const response = await axios.get(`${streetsUrl}/queue-config`, axiosConfig);
    return response.data;
  } catch (error) {
    return { error };
  }
};

export const getFallbackAd = async ({
  partnerName = '',
}: GetDeviceAdsProps): Promise<IAdLoop | null> => {
  try {
    const response = await axios.get(`${streetsUrl}/fallback`, {
      ...axiosConfig,
      params: {
        partnerName,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      '[CLIENT] Error requesting fallback ad:',
      error,
    );
    return null;
  }
};
